import { jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment';
import { getTimezone, useSession } from '../../../../../../infra/session';
import { convert24to12Hour, getScheduledDateTime } from '../../../../../../infra/ui/time-selector/utils';
import { formatDateWithIntl } from '../../../../campaign-list/list-view/table/columns/date-time/utils';
import { CampaignSchedule, getDayOfMonthOptions, getDayOfWeekOptions, getSchedulingOptions, } from '../../campaign-configuration/timeline/input-schema';
import { TimelineOption } from '../../campaign-configuration/timeline/types';
import { CampaignDetailsPreview } from './campaign-details-preview';
import config from '../../../../../../../config';
import { useDeliveryChannel, useEditableField } from '../../../hooks';
import { t } from '../../../../../../infra/i18n';
export var CampaignDetailsPreviewContainer = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var campaign = _a.campaign, audiences = _a.audiences, isAudiencesLoading = _a.isAudiencesLoading;
    var session = useSession().data;
    var timezone = getTimezone(session);
    var availableDeliveryChannelsOptions = useDeliveryChannel().availableDeliveryChannelsOptions;
    var dayOfWeek = useEditableField('dayOfWeek').field;
    var dayOfMonth = useEditableField('dayOfMonth').field;
    var sendTime = useEditableField('sendTime').field;
    var endDate = useEditableField('endDate').field;
    var usesCustomSchedule = useEditableField('usesCustomSchedule').field;
    var frequency = useEditableField('frequency').field;
    var sendDate = useEditableField('sendDate').field;
    var dateFormat = useEditableField('dateFormat').field;
    var _h = getScheduledDateTime(campaign === null || campaign === void 0 ? void 0 : campaign.scheduledAt, timezone, dateFormat.value), scheduledDate = _h.scheduledDate, scheduledTime = _h.scheduledTime;
    var today = moment().format(dateFormat.value);
    var timeline = usesCustomSchedule.value ? 'scheduled' : TimelineOption.SEND_NOW;
    var timelineLabel = usesCustomSchedule.value
        ? t('engage:campaign_builder.review.scheduled')
        : t('engage:campaign_builder.review.send_now');
    var formattedSendDate = sendDate.value ? formatDateWithIntl(sendDate.value) : '-';
    var isOneTimeFrequency = frequency.value === CampaignSchedule.ONE_TIME;
    var isSendNowCampaign = timeline === TimelineOption.SEND_NOW;
    var sendDateShown = isOneTimeFrequency || isSendNowCampaign ? scheduledDate : formattedSendDate;
    var formattedTotalClients = (_b = campaign === null || campaign === void 0 ? void 0 : campaign.totalCustomersNotified) === null || _b === void 0 ? void 0 : _b.toLocaleString('en-US', { minimumFractionDigits: 0 });
    var channelsString = availableDeliveryChannelsOptions.map(function (channel) { return channel.name; }).join(', ');
    var formattedSendTime = sendTime.value ? (_c = convert24to12Hour(sendTime.value)) !== null && _c !== void 0 ? _c : '-' : '-';
    var daysOfWeek = (_e = (_d = getDayOfWeekOptions().find(function (_a) {
        var _b;
        var value = _a.value;
        return value === ((_b = dayOfWeek.value) === null || _b === void 0 ? void 0 : _b.toString());
    })) === null || _d === void 0 ? void 0 : _d.label) !== null && _e !== void 0 ? _e : '-';
    var daysOfMonth = (_g = (_f = getDayOfMonthOptions().find(function (_a) {
        var _b;
        var value = _a.value;
        return value === ((_b = dayOfMonth.value) === null || _b === void 0 ? void 0 : _b.toString());
    })) === null || _f === void 0 ? void 0 : _f.label) !== null && _g !== void 0 ? _g : '-';
    var getStartDate = function () {
        if (isSendNowCampaign && (campaign === null || campaign === void 0 ? void 0 : campaign.status) === 'draft')
            return today;
        if (frequency.value === CampaignSchedule.WEEKLY || frequency.value === CampaignSchedule.BI_WEEKLY)
            return daysOfWeek;
        if (frequency.value === CampaignSchedule.MONTHLY)
            return daysOfMonth;
        return sendDateShown;
    };
    var getTime = function () {
        if ((campaign === null || campaign === void 0 ? void 0 : campaign.status) === 'completed')
            return moment.tz(campaign.completedAt, timezone).format(config.timeFormatUppercase);
        if (isSendNowCampaign && (campaign === null || campaign === void 0 ? void 0 : campaign.status) === 'draft')
            return t('engage:campaign_builder.review.instant');
        if (frequency.value === CampaignSchedule.ONE_TIME)
            return scheduledTime;
        return formattedSendTime;
    };
    var getEndDate = function () {
        if (!endDate.value || isSendNowCampaign)
            return t('engage:campaign_builder.review.no_end_date');
        return formatDateWithIntl(endDate.value);
    };
    var getFrequency = function () {
        var frequencyOption = getSchedulingOptions().find(function (opt) { return opt.value === frequency.value; });
        return (frequencyOption === null || frequencyOption === void 0 ? void 0 : frequencyOption.label) || CampaignSchedule.ONE_TIME;
    };
    var fields = [
        { name: t('engage:campaign_builder.review.channels'), value: channelsString },
        { name: t('engage:campaign_builder.review.timeline'), value: timelineLabel },
        { name: t('engage:campaign_builder.review.frequency'), value: getFrequency() },
        { name: t('engage:campaign_builder.review.time'), value: getTime() },
        { name: t('engage:campaign_builder.review.start_date'), value: getStartDate() },
        { name: t('engage:campaign_builder.review.end_date'), value: getEndDate() },
    ];
    return (_jsx(CampaignDetailsPreview, { fields: fields, isLoading: isAudiencesLoading, audiences: audiences, formattedTotalClients: formattedTotalClients }));
};
